import { render, staticRenderFns } from "./AddictiveStuffClientDelete.vue?vue&type=template&id=7af43dbd&scoped=true&"
import script from "./AddictiveStuffClientDelete.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af43dbd",
  null
  
)

export default component.exports